// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#date .el-form-item__label:before {\r\n  content: '*';\r\n  color: #F56C6C;\r\n  margin-right: 4px\n}\r\n", ""]);
// Exports
module.exports = exports;
